import { createMediaQueries } from '../../styling/helpers';
import { breakpoints } from './breakpoints';

export const mq = createMediaQueries(breakpoints);
